import { Testimonials } from '@frontendmentorio/design-system-v2';

export default function Testimonials3() {
  return (
    <div className="px-5 tablet:pb-6">
      <Testimonials>
        <Testimonials.Card
          avatar="/static/images/pro-avatar-george.webp"
          name="George"
          title="@Olatoyan"
        >
          Having access to the Figma files with PRO saves time and ensures your
          project aligns nicely with the design. Instead of guessing font sizes
          and spacing from images, the Figma file provides precise details. It’s
          truly worth it!
        </Testimonials.Card>

        <Testimonials.Card
          avatar="/static/images/pro-avatar-jakub.webp"
          name="Jakub"
          title="@jakubfiglak"
        >
          The premium challenges allow me to test my skills by building more
          complex websites. I strongly recommend using Frontend Mentor
          challenges to build your portfolio.
        </Testimonials.Card>
      </Testimonials>
    </div>
  );
}
